import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { catchError  } from 'rxjs/operators';
import { Common } from '../ViewModel/Common';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { AddEntityAsset } from '../ViewModel/DASModels/addEntityAssetModel';
import { Entity } from '../ViewModel/DASModels/EntityModel';

@Injectable()
export class MediaService {
  _common = new Common();
  mediaGetURL = environment.MediaWebApiUrl + 'File';
  mediaGetArrayURL = environment.MediaWebApiUrl + 'Files';
  mediaUploadURL = environment.MediaWebApiUrl + 'File/Create';
  mediaDeleteURL = environment.MediaWebApiUrl + 'File/Delete';
  attachmentFileURL = environment.WEBAPIURL + 'common/upload-media';
  serviceUrl =  environment.DASURL + '/api/Entity';
  _uploadManualPermitUrl = environment.WEBAPIURL + 'common/upload-manual'; 
  getImageBlobFromMediaAPI = this._common.MediaURL + 'Media/GetImageByte';
  
  dasHeaderDict  =  {
    'Content-Type':  'application/json',
    'Accept':  'application/json',
    'Access-Control-Allow-Origin':  '*',
    'Access-Control-Allow-Methods':  'GET, POST, PATCH, PUT, DELETE, OPTIONS',
  };
  constructor(private _http: HttpClient ) {       
  }
  
  getFileProperties(AzureFileId: number) {
    
    return this._http.post<any>(this.mediaGetURL +"/" + AzureFileId, AzureFileId, {observe: 'response'});
  }
  getMediaBlob(callUri: string){ 
    return this._http.get<any>(this.getImageBlobFromMediaAPI, {headers: this._common.MediaHeaders,
    params: new HttpParams().set('ImageUrl', callUri)
    });
  }
  getFilePropertiesArray(AzureFileArrayId:any[]) {
    return this._http.post<any>(this.mediaGetArrayURL,AzureFileArrayId, {observe: 'response'});
  }

  UploadMediaFiles(AzureFile: File) {
    const formData = new FormData();
    formData.append('file', AzureFile);
    return this._http.post<any>(this.mediaUploadURL, formData, {observe: 'response'});
  }

  AttachMediaFiles(AzureFile: File) {
    const formData = new FormData();
    formData.append('file', AzureFile);
    return this._http.post<any>(this.attachmentFileURL, formData, {observe: 'response'});
  }

  uploadManualPermits(AzureFile: File,PermitNumber: string) {
    const formData = new FormData();
    formData.append('file', AzureFile);
    formData.append('function','manual');
    formData.append('permitNumber', PermitNumber);
    return this._http.post<any>(this.attachmentFileURL, formData, {observe: 'response'});
  }
  getFileByUri (callUri: string) {    
    return this._http.get<any>(callUri);
  }

  DeleteMediaFileById(AzureFileId: number) { 
    return this._http.post<any>(this.mediaDeleteURL+'/'+AzureFileId, { observe: 'response' });
  }
  
}
  
  // async UploadMediaFiles(AzureFile: File): Promise<any> {
  //   try {
  //     this._common = new Common();
  //     const formData = new FormData();
  //     formData.append('file', AzureFile);
  //     // return this._http.post<any>(this.mediaUploadURL, formData, {
  //     //   observe: 'response',
  //     //   headers: this._common.mediaPostHeader
  //     // })
  //     return await this._http.post<any>(this.mediaUploadURL, formData, {
  //       // observe: 'response',
  //       headers: this._common.mediaPostHeader
  //     }).toPromise();
  //   } 
  //   catch (error) {
  //     await this.handleError(error);
  //   }
  //     // .pipe(
  //     //   catchError(this.handleError)
  //     // );
  // }
